import { TextBlot } from 'parchment';

class Text extends TextBlot {}

export default Text;
